import React, { useState, useContext, useEffect } from "react";
import EmailEditorHeader from "./EmailEditorHeader";
import ElementsSidebar from "./ElementsSidebar";
import Canvas from "./Canvas";
import Settings from "./Settings";
import { Undo2, Redo2, Paperclip } from "lucide-react";
import { EmailTemplateContext } from "../../context/EmailTemplateContext";
import AttachmentDialog from "./AttachmentsDialog";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import CustomToolbar from "./CustomToolbar";
import EmailFieldsBar from "./EmailFieldsBar";

// const EmailTemplateEditor = () => {
//   const [viewHTMLCode, setViewHTMLCode] = useState();
//   const [copy, setCopy] = useState(true);
//   const [testEmail, setTestEmail] = useState();
//   const { attachments, setAttachments, undo, redo, canUndo, canRedo } =
//     useContext(EmailTemplateContext);
//   const [showAttachmentDialog, setShowAttachmentDialog] = useState(false);

//   const handleAttachments = () => {
//     setShowAttachmentDialog(true);
//   };

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if ((e.ctrlKey || e.metaKey) && e.key === "z") {
//         e.preventDefault();
//         undo();
//       }
//       if ((e.ctrlKey || e.metaKey) && e.key === "y") {
//         e.preventDefault();
//         redo();
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [undo, redo]);

//   return (
//     <>
//       <EmailEditorHeader
//         viewHTMLCode={setViewHTMLCode}
//         setCopy={setCopy}
//         testEmail={testEmail}
//         setTestEmail={setTestEmail}
//       />

//       <div className="grid grid-cols-5">
//         <ElementsSidebar />

//         <div className="col-span-3 bg-gray-100 h-[90vh] overflow-y-auto relative">
//           {/* Quill Toolbar positioned at the top */}
//           {/* <CustomToolbar /> */}

//           {/* ✅ Undo/Redo Buttons - Top Left Corner */}
//           <div className="absolute top-2 left-2 flex gap-2 z-10">
//             <button
//               onClick={undo}
//               disabled={!canUndo}
//               className={`p-2 rounded-lg transition ${
//                 canUndo
//                   ? "bg-white hover:bg-gray-100 text-gray-700 shadow-sm"
//                   : "bg-gray-200 text-gray-400 cursor-not-allowed"
//               }`}
//               title="Undo (Ctrl+Z)"
//             >
//               <Undo2 className="w-4 h-4" />
//             </button>
//             <button
//               onClick={redo}
//               disabled={!canRedo}
//               className={`p-2 rounded-lg transition ${
//                 canRedo
//                   ? "bg-white hover:bg-gray-100 text-gray-700 shadow-sm"
//                   : "bg-gray-200 text-gray-400 cursor-not-allowed"
//               }`}
//               title="Redo (Ctrl+Y)"
//             >
//               <Redo2 className="w-4 h-4" />
//             </button>
//           </div>

//           {/* <Paperclip
//             onClick={handleAttachments}
//             className="absolute top-2 right-4 w-4 text-gray-500 hover:text-gray-700 cursor-pointer transition"
//           /> */}

//           {/* Attachment Button */}
//           {/* <button
//             onClick={handleAttachments}
//             className="absolute top-2 right-2 p-2 rounded-lg bg-white hover:bg-gray-100 text-gray-700 shadow-sm transition z-10"
//             title="Attachments"
//           >
//             <Paperclip className="w-4 h-4" />
//           </button> */}

//           <Canvas
//             viewHTMLCode={viewHTMLCode}
//             setViewHTMLCode={setViewHTMLCode}
//             copy={copy}
//             setCopy={setCopy}
//             testEmail={testEmail}
//           />
//         </div>

//         <div>
//           <Settings />
//         </div>
//       </div>

//       {/* Attachment Dialog */}
//       <AttachmentDialog
//         isOpen={showAttachmentDialog}
//         onClose={() => setShowAttachmentDialog(false)}
//         attachments={attachments}
//         setAttachments={setAttachments}
//       />
//     </>
//   );
// };

// export default EmailTemplateEditor;

const EmailTemplateEditor = () => {
  const [viewHTMLCode, setViewHTMLCode] = useState();
  const [copy, setCopy] = useState(true);
  const [testEmail, setTestEmail] = useState();
  const { 
    attachments, 
    setAttachments, 
    undo, 
    redo, 
    canUndo, 
    canRedo,
    sendToCcBccSubject,
    setSendToCcBccSubject 
  } = useContext(EmailTemplateContext);
  const [showAttachmentDialog, setShowAttachmentDialog] = useState(false);
  const [activeField, setActiveField] = useState(null); // 'to', 'cc', 'bcc', 'subject', or null

  const handleAttachments = () => {
    setShowAttachmentDialog(true);
  };

  // Save field value
  const handleSaveField = (fieldName, value) => {
    setSendToCcBccSubject(prev => ({
      ...prev,
      [fieldName]: value
    }));
    setActiveField(null);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "z") {
        e.preventDefault();
        undo();
      }
      if ((e.ctrlKey || e.metaKey) && e.key === "y") {
        e.preventDefault();
        redo();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [undo, redo]);

  return (
    <>
      <EmailEditorHeader
        viewHTMLCode={setViewHTMLCode}
        setCopy={setCopy}
        testEmail={testEmail}
        setTestEmail={setTestEmail}
      />

      <div className="grid grid-cols-5">
        <ElementsSidebar />

        <div className="col-span-3 bg-gray-100 h-[90vh] overflow-y-auto relative">
          {/* ✅ Undo/Redo Buttons - Top Left Corner */}
          {/* <div className="absolute top-2 left-2 flex gap-2 z-10">
            <button
              onClick={undo}
              disabled={!canUndo}
              className={`p-2 rounded-lg transition ${
                canUndo
                  ? "bg-white hover:bg-gray-100 text-gray-700 shadow-sm"
                  : "bg-gray-200 text-gray-400 cursor-not-allowed"
              }`}
              title="Undo"
            >
              <Undo2 className="w-4 h-4" />
            </button>
            <button
              onClick={redo}
              disabled={!canRedo}
              className={`p-2 rounded-lg transition ${
                canRedo
                  ? "bg-white hover:bg-gray-100 text-gray-700 shadow-sm"
                  : "bg-gray-200 text-gray-400 cursor-not-allowed"
              }`}
              title="Redo"
            >
              <Redo2 className="w-4 h-4" />
            </button>
          </div> */}

          {/* Email Fields & Attachment Section - Top Right */}
          <div className="absolute top-2 right-2 z-10">
            <EmailFieldsBar 
              activeField={activeField}
              setActiveField={setActiveField}
              sendToCcBccSubject={sendToCcBccSubject}
              handleSaveField={handleSaveField}
              handleAttachments={handleAttachments}
            />
          </div>

          <Canvas
            viewHTMLCode={viewHTMLCode}
            setViewHTMLCode={setViewHTMLCode}
            copy={copy}
            setCopy={setCopy}
            testEmail={testEmail}
          />
        </div>

        <div>
          <Settings />
        </div>
      </div>

      {/* Attachment Dialog */}
      <AttachmentDialog
        isOpen={showAttachmentDialog}
        onClose={() => setShowAttachmentDialog(false)}
        attachments={attachments}
        setAttachments={setAttachments}
      />
    </>
  );
};

export default EmailTemplateEditor;